
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.998 13.03a2.302 2.302 0 00-2.303-2.303H2.392A2.302 2.302 0 00.09 13.029v3.838a2.302 2.302 0 002.302 2.302h15.303a2.302 2.302 0 002.303-2.302v-3.838zm-15.708.767a1.152 1.152 0 11-.001 2.303 1.152 1.152 0 010-2.303zm3.445 1.918h8.333a.768.768 0 000-1.534H7.735a.768.768 0 000 1.535zM20 3.053A2.302 2.302 0 0017.698.75H2.303A2.302 2.302 0 000 3.053v3.855a2.302 2.302 0 002.303 2.303h15.395A2.302 2.302 0 0020 6.908V3.053zm-15.708.776a1.152 1.152 0 110 2.304 1.152 1.152 0 010-2.304zm3.445 1.919h8.333a.768.768 0 000-1.535H7.737a.768.768 0 000 1.535z","fill":"#E2E8F0"}})])
          )
        }
      }
    